/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = css`
  width: inherit;
  height: auto;
`

export default function GuideIco() {
  return (
    <svg id="tip" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" css={Color}>
      <rect id="사각형_6317" data-name="사각형 6317" width="22" height="22" fill="rgba(255,0,0,0)" opacity="0.3"/>
      <path id="합치기_237" data-name="합치기 237" d="M-1245.374-280.63v-9.356a1.013,1.013,0,0,1,1.013-1.013H-1242a3.831,3.831,0,0,1,3.925,2.937,3.739,3.739,0,0,1-3.772,4.472h-1.5v2.961a1.013,1.013,0,0,1-1.013,1.013A1.014,1.014,0,0,1-1245.374-280.63Zm2.027-4.988h1.5a1.706,1.706,0,0,0,1.82-1.678,1.706,1.706,0,0,0-1.82-1.678h-1.5Zm-6.708,4.988v-9.356a1.013,1.013,0,0,1,1.013-1.013,1.014,1.014,0,0,1,1.013,1.013v9.356a1.014,1.014,0,0,1-1.013,1.013A1.013,1.013,0,0,1-1250.055-280.63Zm-6.68,0v-8.344h-2.252a1.012,1.012,0,0,1-1.013-1.012,1.013,1.013,0,0,1,1.013-1.013h6.529a1.014,1.014,0,0,1,1.013,1.013,1.014,1.014,0,0,1-1.013,1.012h-2.251v8.344a1.013,1.013,0,0,1-1.013,1.013A1.014,1.014,0,0,1-1256.735-280.63Z" transform="translate(1260 296.308)" fill="#141414"/>
    </svg>
  )
}
